<template>
  <Row :gutter="10" type="flex" class="grid-list-row mx-0">
      <Col :span="3" align="middle" class="pointer" @click.native="$emit('openSlider')">
        <p>
          {{order.indent_number}}
        </p>
      </Col>
      <Col :span="3" align="middle" class="pointer" @click.native="$emit('openSlider')">
        <span :class="genericIndentColor(order)" style="display: inline">
          <span style="display: block">
            {{statusName(order.status)}}
            {{subStatusName(order.approval_status)}}
          </span>
          <Tooltip class="item" effect="dark" placement="bottom" style="display: contents">
            <div slot="content" class="tooltipcontent">
             {{order.type === 2 ? 'Ocean' : 'Air'}}
            </div>
            <span class="badge badge-bottom">
              <svgicon v-if="order.type === 2" name="icon-status-ship" width="10" height="10" />
              <svgicon v-if="order.type === 3" name="air_type" width="10" height="10" />
            </span>
          </Tooltip>
        </span>
      </Col>
      <Col :span="4" align="middle" class="pointer" @click.native="$emit('openSlider')">
        <p>
          <Ellipsis :text="routePath()" :length="20"/>
        </p>
      </Col>
      <Col :span="3" align="middle" @click.native="$emit('openSlider')">
        <p>
          &nbsp;
        </p>
      </Col>
      <Col class="col-push text-right" align="middle">
        <Popover
          v-if="isEnabledAction()"
          placement="bottom-end"
          width="500"
          class="link-action"
          :visible-arrow="false"
          popper-class="popover-list bordered"
          v-model="visible">
          <div class="popover-wrapper">
            <div class="popover-title">
               {{order.action.label}}
              <i class="close" @click="visible=false">
                <svgicon name="cancelblack-trans" width="12" height="12" />
              </i>
            </div>
            <div class="popover-body p-0">
              <Form :inline="true" class="form-default form-multi">
                <FormItem  v-for="(column,index) in getFormDetails"
                  :key="index"
                  :label="column.label"
                  :required="column.is_required">
                  <Input
                    v-if="column.input_type === '1'"
                    :placeholder="`Enter ${column.label} here`"
                    type="text"
                    v-model="values.custom_fields[column.key]"
                    @input="setValues($event, column.key)">
                  </Input>
                  <DatePicker
                    v-if="column.input_type === '2'"
                    v-model="values.custom_fields[column.key]"
                    type="date"
                    prefix="false"
                    placeholder="Enter date here">
                  </DatePicker>
                  <Select
                    v-if="column.input_type === '3'"
                    filterable
                    clearable
                    remote
                    :remote-method="data =>fetchDropDown(data, column.api_endpoint, column.drop_down_fields)"
                    v-model="values.custom_fields[column.key]"
                    class="select-default multi-select z-index"
                    value-key="id"
                    placeholder="Select"
                    @change="setValues($event, column.key)">
                    <Option
                        v-for="item in searchDropDownInput"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                        <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.type }}</span> -->
                    </Option>
                  </Select>
                  <Select
                    v-if="column.input_type == '8'"
                    filterable
                    clearable
                    remote
                    :remote-method="fetchContainerTypes"
                    v-model="values.custom_fields[column.key]"
                    class="select-default multi-select z-index"
                    value-key="id"
                    placeholder="Select Container Type"
                    @change="setValues($event, column.key)">
                    <Option
                        v-for="item in containerTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.type }}</span>
                    </Option>
                  </Select>
                </FormItem>
                <FormItem label="Remarks" :required="true" v-if="!disablePopoverAction">
                  <Input
                    class="m-5 form-default"
                    :placeholder="`Remarks`"
                    type="text"
                    v-model="approvalRemark">
                  </Input>
                </FormItem>
              </Form>
              <div class="mx-m1" v-if="showTableContainer && isImportIndent && $hasPermission('update_container_info')">
                <Table
                  :data="tableContainerData"
                  :stripe="true"
                  aria-describedby="tableContainerData"
                  class="table-striped bordered-outline">
                  <table-column
                    prop="sno"
                    label="S.No."
                    width="50">
                  </table-column>
                  <table-column
                    prop="containerName"
                    label="Container Name"
                    width="160">
                  </table-column>
                  <table-column>
                    <template slot-scope="scope" slot="header">
                      Container Numer <span class="text-red">*</span>
                    </template>
                    <template slot-scope="scope">
                      <Input
                        size="mini"
                        :value="scope.row.containerNumber"
                        @input="enterContainer($event, scope.$index)"
                        placeholder="Enter Number"
                        class="input-blank p-0"
                      >
                      </Input>
                    </template>
                  </table-column>
                </Table>
              </div>
              <div
              class="popover-inner pb-0"
               v-if="showAttachmentEntry"
              >
                <div
                  class="popover-doc"
                  v-for="(attachment, ind) in getAttachmentDetail" :key="ind"
                >
                  <label>{{attachment.label}} <span  v-if="attachment.is_required" class="text-red">*</span></label>
                  <div v-if="!disablePopoverAction">
                    <AttachmentDocument
                      :attachments="getAttachmentSpecificDownloadableView(attachment.key)"
                      :oceanLegAttachmentsMeta="attachmentMap"
                    />
                  </div>
                  <div v-else>
                    <AttachmentsMin
                      :maxAllowed=3
                      :attachments="getAttachmentSpecificOrderKey(attachment.key)"
                      :showRemoveDocuments="showRemoveDocuments"
                      v-on:addAttachments="$emit('addAttachments',$event, order, attachment.key)"
                      @removeAttachments="removeAttachments($event)"
                    ></AttachmentsMin>
                  </div>
                </div>
              </div>
              <div
              class="popover-inner pb-0"
               v-if="showOptionalAction"
              >
                <CheckboxGroup v-model="selectedNextAction" display="block" class="text-label" :min=0 :max=1>
                  <Checkbox  v-for="(action, ind) in getOptionalAction" :key="ind" :label="action.id">{{action.label}} is required</Checkbox>
                </CheckboxGroup>
              </div>
            </div>
            <div class="popover-footer pt-0 mt-15" v-if="!disablePopoverAction">
              <Button size="mini" @click="genericIndentApproval(1)">
                Reject
              </Button>
              <Button type="primary" size="mini" @click="genericIndentApproval(0)">
                Approve
              </Button>
            </div>
            <div class="popover-footer pt-0 mt-15" v-if="disablePopoverAction">
              <Button type="primary" size="mini" @click="genericActionSubmit()">
                Submit
              </Button>
            </div>
          </div>
          <span slot="reference">
            {{order.action.label}}
          </span>
        </Popover>
      </Col>
  </Row>
</template>
<script>
import debounce from 'debounce';
import {isEmpty, keyBy} from 'lodash';
import {workflowActionStatus} from 'pando-constants';
import AttachmentsMin from "@common/components/AttachmentsMin";
import {isArray, isObject} from 'lodash';
import AttachmentDocument from './AttachmentDocument';

export default {
  props: {
    order: {
      default: () => {},
      type: Object
    },
    oceanLegAttachmentsMeta: {
      default: () => {},
    },
    showRemoveDocuments:{
      type: Boolean,
      default: false,
    },
    searchPortList: {
      default: () => {},
      type: Object,
    },
    containerDetails: {
      default: () => ([]),
      type: Array,
    },
    isImportIndent:{
      default: false,
      type: Boolean,
    },
    containerTypeList: {
      default: null,
      type: Array,
    },
    searchDropDownInput: {
      default: () => ([]),
      type: Array,
    },
    client_type: {
      default: null,
      type: String,
    }
  },
  components:{
    AttachmentsMin,
    AttachmentDocument,
  },
  created(){
    this.tableContainerData = this.containerDetails;
  },
  data() {
    return {
      values: {
        custom_fields: {},
      },
      visible: false,
      workflowActionStatus,
      tableData: [],
      selectedNextAction: [],
      approvalRemark: '',
      attachmentMap: {},
    };
  },
  computed:{
    orderActionFieldsValidation(){
      return this.order && this.order.action && this.order.action.fields &&
      this.order.action.fields.length;
    },
    getFormDetails(){
      if(this.orderActionFieldsValidation){
        this.$emit('loadDropDownData', this.order);
        this.loadDefault();
        return this.order.action.fields.filter(_field => parseInt(_field.input_type)!==6);
      }
      return [];
    },
    getAttachmentDetail(){
      if(this.orderActionFieldsValidation){
        return this.order.action.fields.filter(_field => parseInt(_field.input_type)===6);
      }
      return [];
    },
    showAttachmentEntry(){
      return this.getAttachmentDetail.length ? true :false;
    },
    showTableContainer(){
      return this.order && this.order.action && this.order.action.requires_container_number;
    },
    showOptionalAction(){
      return this.getOptionalAction.length;
    },
    getOptionalAction() {
      return this.order && this.order.action && this.order.action.enabled_status &&
        this.order.action.enabled_status.filter(status => status.optional_flow);
    },
    getDefaultNextAction() {
      return this.order && this.order.action && this.order.action.enabled_status &&
        this.order.action.enabled_status.filter(status => !status.optional_flow)[0];
    },
    disablePopoverAction() {
      if(this.client_type === 'shipper' && this.order.approval_flow) {
        return false;
      } else if (this.client_type === 'shipper' && !this.order.approval_flow) {
        return this.order.action && this.order.action.label
          && this.$hasPermissions(this.order.action.permissions);
      } else {
        return true;
      }
    },
  },
  methods:{
    loadDefault() {
      this.attachmentMap[this.order.indent_number] = [];
      if (this.order && this.order.approval_flow && this.order.approval_status !== 2
        && this.order.approval_status !== 1) {
        const fields = this.order && this.order.action && this.order.action.fields;
        const fieldMap = keyBy(fields, 'label')
        const fieldsValues = this.order && this.order.field_values;
        const attachments = this.order && this.order.attachments;
        const noneCustomFields = (fieldsValues && fieldsValues.non_custom_field && fieldsValues.non_custom_field.length) || 0;
        for (let i = 0; i < noneCustomFields; i += 1) {
          const _fieldValue = fieldsValues.non_custom_field[i];
          const _field = fieldMap[_fieldValue.label];
          if (_field && _field.key) {
            this.values.custom_fields[_field && _field.key] = _fieldValue.value;
          }
        }
        const attachmentNonCustomFieldLength = (attachments && attachments.non_custom_field && attachments.non_custom_field.length) || 0;
        for (let i = 0; i < attachmentNonCustomFieldLength; i += 1) {
          const _fieldValue = attachments.non_custom_field[i];
          const _field = fieldMap[_fieldValue.label];
          _fieldValue.value.forEach(data => (
            this.attachmentMap[this.order.indent_number].push({
              _id: data.id,
              url: data.metadata.key,
              bucket_name: data.metadata.bucket,
              keyLabel: _field && _field.key,
            })
          ));
        }
      }
    },
    removeAttachments(file) {
      this.$emit('removeAttachments', file);
     },
    searchActionInput(url, dropDownFields) {
    },
    isEnabledAction() {
      const permission = this.order.action && this.order.action.label
        && this.$hasPermissions(this.order.action.permissions);
      if (this.order && this.order.approval_flow) {
        const updatedActionMap = (this.order.updated_action) || {};
        if (this.client_type === 'shipper') {
          return updatedActionMap[this.order.action.action_id] || false
        } else if(this.client_type !== 'shipper') {
          return (permission && !updatedActionMap[this.order.action.action_id] ||
            (permission && updatedActionMap[this.order.action.action_id]
              && (this.order.approval_status === 2 || this.order.approval_status === 0)))
            || false
        } else {
          return permission;
        }
      } else {
        return permission;
      }
    },
    enterContainer: debounce( function set(event, ind){
      this.tableContainerData[ind].containerNumber = event;
      this.tableContainerData = [...this.tableContainerData];
    },100),
    statusName (statusNo){
      return this.workflowActionStatus.find(key => key.id === statusNo).label || '-';
    },
    subStatusName (approvalStatus) {
      if (approvalStatus === 0) {
        return 'Approval Pending';
      }
      if (approvalStatus === 2) {
        return 'Approval rejected';
      }
      return null;
    },
    genericIndentColor(order){
      const statusNo = order.status;
      let color = this.workflowActionStatus.find(key => key.id === statusNo).color;
      if (order.approval_status === 0) {
        color = 'status-yellow';
      }
      if (order.approval_status === 2) {
        color = 'status-red';
      }
      return `status status-icon-bottom ${color}`;
    },
    getAttachmentSpecificOrderKey(key){
      return this.oceanLegAttachmentsMeta[this.order.indent_number]
      && this.oceanLegAttachmentsMeta[this.order.indent_number].filter(_obj => _obj.keyLabel ===key)
      || [];
    },
    getAttachmentSpecificDownloadableView(key){
      return this.attachmentMap[this.order.indent_number]
      && this.attachmentMap[this.order.indent_number].filter(_obj => _obj.keyLabel ===key)
      || [];
    },
    routePath() {
      const defaultLocation = { city: null };
      const sourceDetail  = this.order.source || defaultLocation;
      const destinationDetail  = this.order.destination || defaultLocation;
      return sourceDetail.name && destinationDetail.name && `${sourceDetail.name} - ${destinationDetail.name}`;
    },
    setValues(data, paramKey) {
      this.values.custom_fields[paramKey] = data;
    },
    genericIndentApproval(type) {
      if (!this.approvalRemark) {
        this.$error({ message: 'Remarks can not be empty', dangerouslyUseHTMLString: true });
        return;
      }
      this.$emit('generic-action-approval',  {
        indentNo: this.order.indent_number,
        values: Object.assign({
          nextAction: this.selectedNextAction.length ? this.selectedNextAction[0] : (
            (this.getDefaultNextAction && this.getDefaultNextAction.id) || undefined),
          approval_status: type,
          remark: this.approvalRemark,
        }, {}),
      });
    },
    genericActionSubmit() {
      if(this.getAttachmentDetail.length) {
        this.getAttachmentDetail.forEach((attach, ind)=>{
          const attachments =this.getAttachmentSpecificOrderKey(attach.key);
          if (attach.key) {
            this.values.custom_fields[attach.key] = attachments && attachments.length ? attachments.map(_attach => _attach._id): [];
          }
        });
      }
      let errMsg = [];
      if (this.showTableContainer && this.tableContainerData.length){
        if (this.tableContainerData.some(_container => isEmpty(_container.containerNumber))) {
          errMsg = ["Container Numbers are required"];
        } else {
          this.values.container_details = this.tableContainerData.map(_container =>
            (
              {
                id: _container.containerId,
                container_number: _container.containerNumber
              }
            )
          );
        }
      }
      const requiredFields = (this.order.action.fields &&
        this.order.action.fields.filter(field => field.is_required &&
        (!this.values.custom_fields[field.key])
        )) || [];
      const attachmentFields = this.getAttachmentDetail;
      if(attachmentFields.length){
        const errAttachment = attachmentFields.filter(field => field.is_required && (!this.values.custom_fields[field.key].length))
        if(errAttachment.length){
          requiredFields.push(...errAttachment);
        }
      }
      errMsg = [...errMsg, ...requiredFields.map(field=> `${field.label} is required `)];
      if (errMsg.length) {
        this.$error({ message: errMsg.toString(), dangerouslyUseHTMLString: true });
        return;
      }

      this.$emit('generic-action-submit', {
        indentNo: this.order.indent_number,
        values: Object.assign({
          nextAction: this.selectedNextAction.length ? this.selectedNextAction[0] : (
            (this.getDefaultNextAction && this.getDefaultNextAction.id) || undefined),
        }, this.values),
        actionOn: this.order.action.label,
      });
      this.values = { custom_fields: {} };
      this.selectedNextAction = [];
      this.visible = false;
    },
    fetchContainerTypes: debounce(async function (event) {
      this.$emit('fetch-container-type-list', event);
    }, 300),
    fetchDropDown: debounce(async function search (value, url, column) {
      this.$emit('fetch-drop-down-list', { queryValue: value, url: url, queryField: column.query_field  });
    }, 300),
  }
}
</script>
